import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import WBCModal from "../elements/WBCModal";
import { WBCPrimaryButton } from "../elements/WBCPrimaryButton";
import styled from "styled-components";
import { SendContents } from "./EmailNotificationsStyles";
import EmailNotificationsApi from "../../httpClients/EmailNotificationsApi";

const BodyContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #f2f3f4;
  border-radius: 0.5rem;
  padding: 1rem;
  max-height: 500px;
  overflow-y: auto;
`;
BodyContent.displayName = "BodyContent";

const SubjectLine = styled.div`
  font-weight: bold;
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #ccc;
`;

const RecipientLine = styled.div`
  width: 100%;
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  line-height: 1.5;
  min-height: 1.5em;
`;

const EmailBody = styled.div`
  background-color: white;
  padding: 1rem;
  border-radius: 0.25rem;
  border: 1px solid #ddd;
`;

const FooterContent = styled.div`
  display: flex;
  flex-direction: row;
  & button {
    margin-left: 0.5rem;
  }
`;
FooterContent.displayName = "FooterContent";

const EmailPreviewModal = ({ isOpen, setIsOpen, emailIdsSelected, handleSend }) => {
  const [emailData, setEmailData] = useState(null);

  useEffect(() => {
    if (emailIdsSelected?.length) {
      EmailNotificationsApi.getNotificationPreviewById(emailIdsSelected[0]).then(res => {
        setEmailData(res);
      });
    }
    return () => {
      setEmailData(null);
    };
  }, [emailIdsSelected]);

  const onSend = () => {
    handleSend();
    setIsOpen(false);
  };

  return (
    <WBCModal isOpen={isOpen} toggleModal={setIsOpen} headerText="Email Preview">
      <BodyContent>
        {emailData ? (
          <>
            <SubjectLine>
              <strong>Subject:</strong> {emailData.subject}
            </SubjectLine>
            <RecipientLine title={emailData.recipients?.join(", ")}>
              <strong>Recipients:</strong> {emailData.recipients?.join(", ") || "No recipients set"}
            </RecipientLine>
            <EmailBody dangerouslySetInnerHTML={{ __html: emailData.body }} />
          </>
        ) : (
          <div>Loading preview...</div>
        )}
      </BodyContent>

      <FooterContent>
        <WBCPrimaryButton disabled={!emailIdsSelected?.length || !emailData?.recipients?.length} onClick={onSend}>
          <SendContents>
            <i className="fas fa-paper-plane mt-1"></i>Send
          </SendContents>
        </WBCPrimaryButton>
      </FooterContent>
    </WBCModal>
  );
};

EmailPreviewModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  emailIdsSelected: PropTypes.array.isRequired,
  handleSend: PropTypes.func.isRequired
};

export default EmailPreviewModal;
